/* eslint-disable consistent-return */
/* eslint-disable import/no-cycle */
import axios from "axios";
import authSvc from "services/authSvc";
import { Alert, AlertType } from "utils/Alert";

let BASE_URL_CALL_REPORT = '';
let BASE_URL_WA_REPORT = '';
let BASE_URL_EMAIL_REPORT = '';
let BASE_URL_SMS_REPORT = '';
let BASE_URL_GENERATE_REPORT = '';
let BASE_URL_WA_TEMPLATE = '';
let BASE_URL_APPLICATION = '';
const BASE_URL_EXTERNAL = 'https://external-user.ocatelkom.co.id';
let BASE_URL_NEW_WA_TEMPLATE = '';

// const data = JSON.parse(localStorage.getItem('oca_user'));

if (localStorage.getItem('current_set') === 'staging') {
  BASE_URL_CALL_REPORT = process.env.REACT_APP_CALL_REPORT_STAGING
  BASE_URL_WA_REPORT = process.env.REACT_APP_WA_REPORT_STAGING
  BASE_URL_EMAIL_REPORT = process.env.REACT_APP_EMAIL_REPORT_STAGING
  BASE_URL_SMS_REPORT = process.env.REACT_APP_SMS_REPORT_STAGING
  BASE_URL_GENERATE_REPORT = process.env.REACT_APP_MEAPI_STAGING
  BASE_URL_WA_TEMPLATE = process.env.REACT_APP_WA_TEMPLATE
  // BASE_URL_EXTERNAL = process.env.REACT_APP_EXTERNAL_URL_STAGING
  BASE_URL_APPLICATION = process.env.REACT_APP_MEAPI_STAGING
  BASE_URL_NEW_WA_TEMPLATE = process.env.REACT_APP_NEW_WA_TEMPLATE
} else {
  BASE_URL_CALL_REPORT = process.env.REACT_APP_CALL_RECORD
  BASE_URL_WA_REPORT = process.env.REACT_APP_WA_RECORD
  BASE_URL_EMAIL_REPORT = process.env.REACT_APP_EMAIL_RECORD
  BASE_URL_SMS_REPORT = process.env.REACT_APP_SMS_REPORT_RATE
  BASE_URL_GENERATE_REPORT = process.env.REACT_APP_DASHBOARD_DOC_URL
  BASE_URL_WA_TEMPLATE = process.env.REACT_APP_WA_TEMPLATE_PROD
  BASE_URL_APPLICATION = process.env.REACT_APP_DASHBOARD_DOC_URL
  BASE_URL_NEW_WA_TEMPLATE = process.env.REACT_APP_NEW_WA_TEMPLATE
  // BASE_URL_EXTERNAL = process.env.REACT_APP_EXTERNAL_URL
}

// BASE_URL_CALL_REPORT = process.env.REACT_APP_CALL_RECORD
// BASE_URL_WA_REPORT = process.env.REACT_APP_WA_RECORD
// BASE_URL_EMAIL_REPORT = process.env.REACT_APP_EMAIL_RECORD
// BASE_URL_SMS_REPORT = process.env.REACT_APP_SMS_REPORT_RATE
// BASE_URL_GENERATE_REPORT = process.env.REACT_APP_DASHBOARD_DOC_URL
// BASE_URL_WA_TEMPLATE = process.env.REACT_APP_WA_TEMPLATE_PROD
// BASE_URL_APPLICATION = process.env.REACT_APP_DASHBOARD_DOC_URL
// BASE_URL_NEW_WA_TEMPLATE = process.env.REACT_APP_NEW_WA_TEMPLATE

const axiosAdmin = axios.create({
  baseURL: process.env.REACT_APP_DASHBOARD_DOC_URL,
  headers: {
    "content-type": "application/json",
  },
  params: {
    noauth: true,
  },
  responseType: "json",
});

const axiosUser = axios.create({
  baseURL: BASE_URL_APPLICATION,
  headers: {
    "content-type": "application/json",
  },
  responseType: "json",
});

const axiosUserApplicatoin = axios.create({
  baseURL: BASE_URL_APPLICATION,
  headers: {
    "content-type": "application/json",
  },
  responseType: "json",
});

const axiosUserSMSAPI = axios.create({
  baseURL: BASE_URL_SMS_REPORT,
  headers: {
    "content-type": "application/json",
  },
  responseType: "json",
});

const axiosUserWA = axios.create({
  baseURL: BASE_URL_WA_REPORT,
  headers: {
    "content-type": "application/json",
  },
  responseType: "json",
});

const axiosUserEmail = axios.create({
  baseURL: BASE_URL_EMAIL_REPORT,
  headers: {
    "content-type": "application/json",
  },
  responseType: "json",
});

const axiosUserCall = axios.create({
  baseURL: BASE_URL_CALL_REPORT,
  headers: {
    "content-type": "application/json",
  },
  responseType: "json",
});

const axiosGenerateReport = axios.create({
  baseURL: BASE_URL_GENERATE_REPORT,
  headers: {
    "content-type": "application/json"
  },
  responseType: "json",
});

const axiosWaTemplate = axios.create({
  baseURL: BASE_URL_WA_TEMPLATE,
  headers: {
    "content-type": "application/json"
  },
  responseType: "json",
});

const axiosExternal = axios.create({
  baseURL: BASE_URL_EXTERNAL,
  responseType: "json",
});

const axiosNewWATemplate = axios.create({
  baseURL: BASE_URL_NEW_WA_TEMPLATE,
  headers: {
    "content-type": "application/json"
  },
  responseType: "json",
});

const createConfig = (config) => {
  const user = authSvc.currentUser();
  if (user) {
    const updatedConfig = {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${user.token}`,
      },
    };
    return updatedConfig;
  }
  return config;
};

const createAxiosResponseInterceptor = (instance) => {
  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error?.response?.status === 401) {
        Alert.showStatus(
          AlertType.ERROR,
          'Error!',
          error.message || error
        )
        authSvc.logout();
        window.location.reload();
      }else if(error?.response?.status === 500){
        Alert.showStatus(
          AlertType.ERROR,
          'Error!',
          error.message || error
        )
        authSvc.logout();
        window.location.reload();
      }
      return Promise.reject(error);
    }
  );
};


axiosAdmin.interceptors.request.use(createConfig);
axiosUser.interceptors.request.use(createConfig);
axiosGenerateReport.interceptors.request.use(createConfig);
axiosWaTemplate.interceptors.request.use(createConfig);
axiosUserApplicatoin.interceptors.request.use(createConfig);


createAxiosResponseInterceptor(axiosAdmin);
createAxiosResponseInterceptor(axiosUser);
createAxiosResponseInterceptor(axiosGenerateReport);
createAxiosResponseInterceptor(axiosWaTemplate);
createAxiosResponseInterceptor(axiosUserApplicatoin);
createAxiosResponseInterceptor(axiosUserSMSAPI);
createAxiosResponseInterceptor(axiosUserWA);
createAxiosResponseInterceptor(axiosUserEmail);
createAxiosResponseInterceptor(axiosUserCall);
createAxiosResponseInterceptor(axiosExternal);
createAxiosResponseInterceptor(axiosNewWATemplate);
// axiosUser.interceptors.response.use(
//   (response) => {
//     console.log('intercept', response)
//     return response;
//   },
//   (error) => {
//     console.log('intercept', error)
//     if (error?.response?.status === 401) {
//       Alert.showStatus(
//         AlertType.ERROR,
//         'Error!',
//         error.message || error
//       )
//       authSvc.logout();
//       window.location.reload();
//     }else if(error?.response?.status === 500){
//       Alert.showStatus(
//         AlertType.ERROR,
//         'Error!',
//         error.message || error
//       )
//       authSvc.logout();
//       window.location.reload();
//     }
//     return Promise.reject(error);
//   }
// );

export {
  axiosAdmin, axiosUser, axiosUserSMSAPI, axiosUserWA,
  axiosUserEmail, axiosUserCall, axiosGenerateReport,
  axiosWaTemplate, axiosExternal,axiosUserApplicatoin,
  axiosNewWATemplate
};
